import styled from '@emotion/styled';

export const StyledModal = styled.div`
  @keyframes pageTransit {
    from {
      transform: translateY(-100%);
    }
    to {
      transform: translateY(0px);
    }
  }

  .drawer-container {
    width: 100vw;
    position: fixed;
    top: 0;
    left: 0px;
    height: 100%;
    background: #fff;
    transition: all 0.3s ease-in-out;
    transform: translate(0);
    padding: 24px 20px;
    z-index: 5;
    animation-name: pageTransit;
    animation-duration: 0.3s;
    box-shadow: 0px 4px 16px 0px #26275833;
  }

  .closing {
    animation-duration: 0.3s;
    transform: translateY(-100%);
  }

  @media screen and (max-width: 576px) {
    .drawer-container {
      width: 100vw;
    }
  }

  @media screen and (min-width: 576px) {
    .drawer-container {
      padding: 24px 48px;
    }
  }

  @media screen and (min-width: 1900px) {
    .drawer-container {
      padding: 35px 60px;
    }
  }
  @media screen and (min-width: 2800px) {
    .drawer-container {
      padding: 70px 120px;
    }
  }
`;
